/*
 * @Author: zhengxiaowen
 * @Date: 2018-08-10 14:52:26
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2018-10-22 10:26:03
 */
import platform from '../config/platform'

let host = platform.host


// *** 业务模块 start ***

// *** 业务模块 end ***

let api = {
  //   // 登录
  // login: `${host}/baseServer/baseLoginService/login`,
  //   // 根据人员查询职位
  // findPositionByPersonId: `${host}/baseServer/baseOrgStructureService/findPositionByPersonId`,
  //   // 根据职位查询部门
  // findPaginationPersonInfo: `${host}/baseServer/baseOrgStructureService/findPaginationPersonInfo`,
  //   // 数据字典
  // findDic: `${host}/baseServer/baseLookupValuesService/findDic`,

  //   // 附件上传
  // fileUploadService_imgUpload: `${host}/baseServer/fileUploadService/imgUpload`,
  // base64ImgUpload: `${host}/baseServer/fileUploadService/base64ImgUpload`,

  //   // 获取导购员信息
  // oaHrGuideRService_findGuideInfo: `${host}/cccAppServer/oaHrGuideRService/findGuideInfo`,

  //   // ***** 流程 start *****

  //   // 发起流程
  // bpmProcessService_start: `${host}/bpmServer/bpmProcessService/start`,

  //   // 撤回流程
  // bpmTaskService_revoke: `${host}/bpmServer/bpmTaskService/revoke`,

  //   // 审批记录
  // bpmHistoryService_findHistoricActivities: `${host}/bpmServer/bpmHistoryService/findHistoricActivities`


    // ***** 流程 end *****

}


// *** 业务模块 start ***

// *** 业务模块 end ***

export default api



// WEBPACK FOOTER //
// ./src/page/apiPage.js